'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'flux-capacitor';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f8ba';
var svgPathData = ['M283.42857,365.71429a27.42857,27.42857,0,1,1-54.85714,0V318.49142a54.85713,54.85713,0,1,0,54.85714,0ZM146.28571,91.42857a54.85715,54.85715,0,0,0,0,109.71429,54.12623,54.12623,0,0,0,14.02287-2.04571l-33.45144-33.38286a27.47615,27.47615,0,0,1,38.85715-38.85715l33.41714,33.41715a54.12633,54.12633,0,0,0,2.01143-13.98858A54.9143,54.9143,0,0,0,146.28571,91.42857ZM420.57143,0H91.42857A91.53143,91.53143,0,0,0,0,91.42857V420.57143A91.53142,91.53142,0,0,0,91.42857,512H420.57143A91.5314,91.5314,0,0,0,512,420.57143V91.42857A91.53142,91.53142,0,0,0,420.57143,0ZM365.71429,237.71429a90.41156,90.41156,0,0,1-41.98856-10.65144L283.42857,267.36v11.57715c37.00572,11.70285,64,45.90855,64,86.77714a91.42857,91.42857,0,1,1-182.85714,0c0-40.86859,26.99428-75.07429,64-86.77714V267.36l-40.29714-40.29713a90.41135,90.41135,0,0,1-41.98858,10.65142,91.42858,91.42858,0,1,1,91.42858-91.42858,90.42306,90.42306,0,0,1-10.66286,41.98858L256,217.21143l28.94857-28.93716a90.42292,90.42292,0,0,1-10.66286-41.98856,91.42858,91.42858,0,1,1,91.42858,91.42858Zm0-146.28572a54.9143,54.9143,0,0,0-54.85715,54.85714,54.12625,54.12625,0,0,0,2.04573,14.02287l33.38284-33.45144a27.47615,27.47615,0,1,1,38.85715,38.85715l-33.41713,33.41714a54.12612,54.12612,0,0,0,13.98856,2.01143,54.85715,54.85715,0,0,0,0-109.71429Z', 'M385.14286,165.71429,283.42857,267.42857v98.28572a27.42857,27.42857,0,1,1-54.85714,0V267.36L126.85714,165.64572a27.45192,27.45192,0,0,1,38.85715-38.78858h0L256,217.14286l90.28571-90.28572a27.47615,27.47615,0,1,1,38.85715,38.85715Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faFluxCapacitor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;